var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FDDFB4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 32,
    height: 32,
    rx: 16,
    stroke: "#FEF5E7",
    strokeWidth: 5.33333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1 23.74V14.26C18.1 13.36 17.72 13 16.76 13H14.34C13.38 13 13 13.36 13 14.26V23.74C13 24.64 13.38 25 14.34 25H16.76C17.72 25 18.1 24.64 18.1 23.74Z",
    stroke: "#F49D1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9994 23.74V14.26C24.9994 13.36 24.6194 13 23.6594 13H21.2394C20.2861 13 19.8994 13.36 19.8994 14.26V23.74C19.8994 24.64 20.2794 25 21.2394 25H23.6594C24.6194 25 24.9994 24.64 24.9994 23.74Z",
    stroke: "#F49D1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseRounded);
export default __webpack_public_path__ + "static/media/pause-rounded.f91dd99ecfea8b43e23bb57b33b460fd.svg";
export { ForwardRef as ReactComponent };